import React, { FC } from 'react';
import { Box } from '@mui/material';
import OrderReviewFilter from '../order-review-filter/order-review-filter.component';
import { OrderSummary, OrderReviewFilterType, ReviewOrders } from 'models/invoice';

type OrderReviewPageActionsProps = {
    onOrderReviewFilterChange: (orderReviewFilter: OrderReviewFilterType) => void;
    onClear: () => void;
    orderSummary: OrderSummary;
    orderReviewFilter: OrderReviewFilterType;
    selectedReviewOrders: ReviewOrders[];
};
const OrderReviewPageActions: FC<OrderReviewPageActionsProps> = ({
    onClear,
    onOrderReviewFilterChange,
    orderReviewFilter,
    orderSummary,
    selectedReviewOrders,
}: OrderReviewPageActionsProps) => {
    return (
        <Box
            sx={{
                marginTop: 1,
                marginBottom: 2,
                bgcolor: 'background.paper',
                padding: 2,
                border: '1px solid',
                borderColor: 'divider',
            }}
        >
            <OrderReviewFilter filters={orderReviewFilter} onOrderReviewFilterChange={onOrderReviewFilterChange} />
        </Box>
    );
};

export default OrderReviewPageActions;
